import { LOCAL_STORAGE_DECLINE_NOTIFICATIONS_KEY } from '../../config/constants';
import localStore from '../../lib/storage/localStore';

const areNotificationsDenied = async (): Promise<boolean> => {
  const hasDeclinedNotifications = await localStore.getItem<boolean>(
    LOCAL_STORAGE_DECLINE_NOTIFICATIONS_KEY
  );

  if (hasDeclinedNotifications || Notification.permission === 'denied') {
    return true;
  }

  return false;
};

export default areNotificationsDenied;
